// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"600":"b652c520","939":"2059629b"}[chunkId] + ".css";
};